var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { width: "16px", height: "16px" },
      attrs: { viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }